<div class="max-w-lg md:px-6 md:pt-6">
  <ng-container *ngIf="page === 'value_proposition'; else instructions">
    <div class="mb-5 flex items-start flex-row gap-4">
      <div class="mb-2 text-lg font-bold md:text-xxl md:mb-4 grow">
        Opłacaj rachunki w <span class="whitespace-nowrap">{{ data.billGatewayApp.displayName }}</span>
      </div>
      <div class="mb-4 md:mb-0 md:ml-4 max-w-[8rem] h-[4rem] shrink-0 relative">
        <img
          class="object-contain h-full"
          [src]="'assets/img/apps/' + data.billGatewayApp.code + '.png'"
          [alt]="data.billGatewayApp.displayName"
        />
      </div>
    </div>
    <div
      class="mb-4 -mx-4 sm:mx-auto sm:rounded-md border-y sm:border border-dashed p-4 text-sm leading-tight text-primary-600 border-primary-500 bg-primary-50 md:mb-8 md:p-6"
    >
      <h2 class="mb-6 font-bold">Dzięki aktywacji usługi zyskasz:</h2>
      <ul class="mb-6">
        <ng-container *ngFor="let benefit of data.billGatewayApp.benefits">
          <li class="mb-4 flex items-center">
            <div
              class="mr-2 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border bg-white border-primary-200"
            >
              <app-icon class="icon-20 text-primary-500">
                <ng-container *ngIf="benefit === Benefit.NO_COMMISSION">price_check</ng-container>
                <ng-container *ngIf="benefit === Benefit.ALL_INVOICES_IN_ONE_PLACE">checklist_rtl</ng-container>
                <ng-container *ngIf="benefit === Benefit.MULTI_INVOICE_PAYMENTS">payments</ng-container>
                <ng-container *ngIf="benefit === Benefit.PAYMENT_DEFERMENT">event_upcoming</ng-container>
                <ng-container *ngIf="benefit === Benefit.CREDIT_CARD">credit_card</ng-container>
                <ng-container *ngIf="benefit === Benefit.AUTOPAYMENT">autopay</ng-container>
              </app-icon>
            </div>
            <span class="text-sm">
              <ng-container *ngIf="benefit === Benefit.NO_COMMISSION">
                Płatności <span class="font-semibold">bez prowizji</span>
              </ng-container>
              <ng-container *ngIf="benefit === Benefit.ALL_INVOICES_IN_ONE_PLACE">
                <span class="font-semibold">Podgląd salda</span> u wszystkich Twoich dostawców usług
              </ng-container>
              <ng-container *ngIf="benefit === Benefit.MULTI_INVOICE_PAYMENTS">
                Opłacanie <span class="font-semibold">wielu</span> rachunków
                <span class="font-semibold">jednym kliknięciem</span>
              </ng-container>
              <ng-container *ngIf="benefit === Benefit.PAYMENT_DEFERMENT">
                Możliwość <span class="font-semibold">odroczenia</span> rachunków o 30 dni
              </ng-container>
              <ng-container *ngIf="benefit === Benefit.CREDIT_CARD">
                Płatności zapisaną <span class="font-semibold">kartą płatniczą</span>
              </ng-container>
              <ng-container *ngIf="benefit === Benefit.AUTOPAYMENT">
                <span class="font-semibold">Autopłatności</span>
              </ng-container>
            </span>
          </li>
        </ng-container>
      </ul>

      <p>
        Od tej pory wszystkie Twoje faktury od <span class="font-semibold">{{ data.biller }}</span> będą przekazywane do
        <span class="font-semibold">{{ data.billGatewayApp.displayName }}</span> automatycznie.
      </p>
    </div>

    <div class="flex flex-col items-center">
      <button (click)="submit()" mat-flat-button color="primary">
        <span class="sm:px-6">DALEJ</span>
      </button>

      <span class="mb-1"></span>

      <button mat-button matDialogClose="cancel">
        <span class="text-gray-700">ANULUJ</span>
      </button>
    </div>
  </ng-container>
</div>

<ng-template #instructions>
  <ng-container *ngIf="data.billGatewayApp.code === 'aliorbank'">
    <div class="mb-5 flex items-center flex-row">
      <div class="mb-2 text-lg font-bold md:text-xxl md:mb-4 grow">
        Włącz Moje rachunki w {{ data.billGatewayApp.displayName }}
      </div>
    </div>

    <iframe
      class="w-full aspect-[16/9] mb-4"
      src="https://www.youtube.com/embed/8QCeLx-Botk?controls=0&autoplay=1"
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>

    <div
      class="mb-4 -mx-4 sm:mx-auto sm:rounded-md border-y sm:border border-dashed p-4 text-sm leading-tight text-primary-600 border-primary-500 bg-primary-50 md:mb-8 md:p-6"
    >
      <ol class="mb-6 list-decimal list-inside">
        <li class="mb-2">
          Zaloguj się {{ platform === 'desktop' ? 'do bankowości Alior' : 'w aplikacji Alior Mobile' }}
        </li>
        <li class="mb-2">
          Wejdź w zakładkę {{ platform === 'desktop' ? 'Płatności' : 'Płatności i Usługi' }} i wybierz opcję Moje
          rachunki
        </li>
        <li class="mb-2">
          Wybierz dostawcę <span class="font-semibold">{{ data.biller }}</span>
        </li>
        <li class="mb-2">Podaj login i hasło</li>
      </ol>

      <p>
        Od tej pory wszystkie Twoje faktury od <span class="font-semibold">{{ data.biller }}</span> będą przekazywane do
        <span class="font-semibold">{{ data.billGatewayApp.displayName }}</span> automatycznie.
      </p>
    </div>
  </ng-container>
  <ng-container *ngIf="data.billGatewayApp.code === 'velobank'">
    <div class="mb-5 flex items-center flex-row">
      <div class="mb-2 text-lg font-bold md:text-xxl md:mb-4 grow">
        Włącz Moje rachunki w {{ data.billGatewayApp.displayName }}
      </div>
    </div>

    <div
      class="mb-4 -mx-4 sm:mx-auto sm:rounded-md border-y sm:border border-dashed p-4 text-sm leading-tight text-primary-600 border-primary-500 bg-primary-50 md:mb-8 md:p-6"
    >
      <ol class="mb-6 list-decimal list-inside">
        <li class="mb-2">
          Zaloguj się {{ platform === 'desktop' ? 'do bankowości ' : 'w aplikacji ' }}
          {{ data.billGatewayApp.displayName }}
        </li>
        <li class="mb-2">
          Wejdź w zakładkę Usługi i wybierz opcję Moje rachunki
        </li>
        <li class="mb-2">
          Wybierz dostawcę <span class="font-semibold">{{ data.biller }}</span>
        </li>
        <li class="mb-2">Podaj login i hasło</li>
      </ol>

      <p>
        Od tej pory wszystkie Twoje faktury od <span class="font-semibold">{{ data.biller }}</span> będą przekazywane do
        <span class="font-semibold">{{ data.billGatewayApp.displayName }}</span> automatycznie.
      </p>
    </div>
  </ng-container>

  <div class="flex flex-col items-center">
    <button (click)="submit()" mat-flat-button color="primary">
      <span class="sm:px-6">DALEJ</span>
    </button>

    <span class="mb-1"></span>

    <button mat-button matDialogClose="cancel">
      <span class="text-gray-700">ANULUJ</span>
    </button>
  </div>
</ng-template>
